angular.module('todo', ['core', 'files', 'document', 'clients', 'task-project'])
    .factory('Todo', function ($resource) {
        return $resource('/crm/api/todo/:id', {id: "@id"}, {
            table: {method: 'GET', isArray: false, url: '/crm/api/todo/table'},
            tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/todo/table-statistics'},
            get: {method: 'GET'},
            update: {method: 'PUT'},
            predecessors: {method: 'GET', isArray: true, url: "/crm/api/todo/:id/predecessors"},
            savePredecessor: {method: 'POST', url: "/crm/api/todo/:id/predecessors"},
            deletePredecessor: {method: 'DELETE', url: "/crm/api/todo/:id/predecessors/:item", params: {item: "@item"}},
            successors: {method: 'GET', isArray: true, url: "/crm/api/todo/:id/successors"},
            subTodo: {method: 'GET', isArray: true, url: "/crm/api/todo/:id/sub-todo"},
            subTodoSave: {method: 'POST', url: "/crm/api/todo/:id/sub-todo"},
            subTodoUpdate: {method: 'PUT', url: "/crm/api/todo/:id/sub-todo"},
            moveSubTodo: {method: 'PUT', url: "/crm/api/todo/:id/parent"},
            changeStatus: {method: 'PUT', url: "/crm/api/todo/:id/status"},
            updateTopic: {method: 'PUT', url: "/crm/api/todo/:id/topic"},
            updateDescription: {method: 'PUT', url: "/crm/api/todo/:id/description"},
            updateDateOfIssue: {method: 'PUT', url: "/crm/api/todo/:id/date-of-issue"},
            privilegeCheck: {method: 'POST', url: "/crm/api/todo/privilege-check"},
            lastComments: {method: 'POST', isArray: true, url: "/crm/api/todo/last-comments"}
        });
    })
    .service('TodoService', function ($rootScope, modals, Todo) {
        this.statuses = () => ['SCHEDULED', 'STARTED', 'ACCOMPLISHED', 'VERIFICATION', 'DONE_NEGATIVE', 'DONE_POSITIVE']
        this.add = params => {
            let defaultParams = {}
            angular.extend(defaultParams, params)
            return modals.open('app/todo/edit-modal.html', 'TodoEditController', defaultParams, {size: "md"}, "$ctrl")
        }
        this.show = (id) => {
            return modals.open('app/todo/show-modal.html', 'TodoShowModalController', {id: id}, {size: "lg"}, "$ctrl")
        }
        this.edit = (id) => {
            return modals.open('app/todo/edit-modal.html', 'TodoEditController', {id: id}, {size: "md"}, "$ctrl")
        }
        this.remove = item => {
            return modals.confirmDelete(item.topic, () => Todo.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast('todo.deleted')))
        }
        this.clone = item => {
            let params = {
                topic: item.topic,
                description: item.description,
                priority: item.priority,
                dateOfIssue: item.dateOfIssue,
                responsible: item.responsible,
                moderator: item.moderator,
                supervisor: item.supervisor,
                projects: item.projects,
                subscriberGroups: item.subscriberGroups,
                subscribers: item.subscribers
            }
            return this.add(params)
        }
        this.deleteChild = item => {
            return modals.confirmDelete(item.topic, () => Todo.delete({id: item.id}).$promise)
        }
        this.moveChild = (item, currentParentId) => {
            return this.select([item.id, currentParentId]).then(parent => {
                return Todo.moveSubTodo({id: item.id}, {item: parent.id}).$promise.then(() => $rootScope.$broadcast('todo.updated'))
            })
        }
        this.changeStatus = (id, status) => {
            return modals.open('app/todo/change-status-modal.html', 'TodoChangeStatusController', {id: id, status: status}, {size: "md"}, "$ctrl")
        }
        this.updateTopic = (id, $data) => {
            return Todo.updateTopic({id: id}, {topic: $data}).$promise.then(() => $rootScope.$broadcast('todo.updated'))
        }
        this.updateDescription = (id, $data) => {
            return Todo.updateDescription({id: id}, {description: $data}).$promise.then(() => $rootScope.$broadcast('todo.updated'))
        }
        this.updateDateOfIssue = (id, $data) => {
            return Todo.updateDateOfIssue({id: id}, {dateOfIssue: $data}).$promise.then(() => $rootScope.$broadcast('todo.updated'))
        }
        this.select = (alreadySelectedIds) => {
            return modals.open('app/todo/select-modal.html', 'TodoSelectController', {alreadySelectedIds: alreadySelectedIds}, {size: "lg"}, "$ctrl");
        }
        this.addPredecessor = (id, selected) => {
            return this.select(selected).then(item => {
                Todo.savePredecessor({id: id, item: item.id}).$promise.then(() => $rootScope.$broadcast('todo.predecessor.updated'))
            })
        }
        this.removePredecessor = (todoId, id) => {
            return Todo.deletePredecessor({id: todoId, item: id}).$promise.then(() => $rootScope.$broadcast('todo.predecessor.updated'))
        }
    })
    .controller('TodoSelectController', function ($scope, $rootScope, $uibModalInstance, Todo, TodoService, data) {
        this.reset = () => this.filters = this.primaryFilters
        this.filters = data;

        this.$onInit = () => {
            this.primaryFilters = angular.copy(this.filters)
            this.loadData()
        }
        this.select = selected => $uibModalInstance.close(selected)
        this.cancel = () => $uibModalInstance.dismiss('cancel')

        this.loadData = () => {
            let filters = angular.copy(this.filters);
            Todo.table(filters).$promise.then(result => this.items = result)
        }

        this.isAlreadySelected = (id) => {
            return Array.isArray(this.filters.alreadySelectedIds) && this.filters.alreadySelectedIds.includes(id);
        }
    })
    .controller('TodoEditController', function ($scope, $rootScope, $uibModalInstance, Todo, data) {
        this.$onInit = () => {
            if (data.id != null)
                Todo.get({id: data.id}).$promise.then((todo) => this.item = todo)
            else {
                this.item = data;
                this.onPrivilegeChanged();
            }
        }

        this.save = () => {
            let promise
            if (this.item.id != null) {
                promise = Todo.update(this.item).$promise
            } else {
                promise = Todo.save(this.item).$promise
            }
            return promise.then(() => {
                $uibModalInstance.close()
                $rootScope.$broadcast('todo.updated')
            })
        }

        this.onPrivilegeChanged = () => {
            let form = {
                projects: this.item.projects,
                responsible: this.item.responsible,
                moderator: this.item.moderator,
                supervisor: this.item.supervisor,
                subscribers: this.item.subscribers,
                subscriberGroups: this.item.subscriberGroups,
                createdBy: this.item.audit?.createdBy
            }
            this.privilegeCheck = {}
            Todo.privilegeCheck(form).$promise.then(result => {
                    this.privilegeCheck = result
                }
            );
        }

        this.cancel = () => $uibModalInstance.dismiss('cancel')
    })
    .controller('TodoShowModalController', function ($scope, $rootScope, $uibModalInstance, Todo, data, TodoService, Principal) {
        this.TodoService = TodoService
        this.$onInit = () => {
            Todo.get({id: data.id}).$promise.then(item => {
                this.item = item
                this.refreshPrivileges()
            })
            Todo.subTodo({id: data.id}).$promise.then(items => this.children = items)
            this.loadPredecessors()
            this.loadSuccessors()
        }
        this.loadPredecessors = () => Todo.predecessors({id: data.id}).$promise.then(items => this.predecessors = items)
        this.loadSuccessors = () => Todo.successors({id: data.id}).$promise.then(items => this.successors = items)

        this.cancel = () => $uibModalInstance.dismiss('cancel')
        $scope.$on('todo.updated', () => this.$onInit())
        $scope.$on('todo.deleted', () => this.cancel())
        $scope.$on('task-project.updated', () => this.$onInit())
        $scope.$on('todo.predecessor.updated', () => this.loadPredecessors())
        $scope.$on('todo.successor.updated', () => this.loadSuccessors())

        this.saveSubTodo = () => {
            return Todo.subTodoSave({id: this.item.id}, this.subTodo).$promise.then(() => {
                this.$onInit()
                delete this.subTodo
            })
        }

        this.refreshPrivileges = () => {
            Principal.currentUser().then(user => {
                this.isCreator = this.item.audit.createdBy.id === user.id && this.item.moderator == null
                this.isModerator = this.item.moderator != null && this.item.moderator.id === user.id
                this.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN'])
            })
        }

        this.canModifyPredecessorsSuccessors = () => {
            return this.isCreator === true || this.isModerator === true || this.isAdmin === true
        }

        this.canDeleteChild = () => {
            return this.isCreator === true || this.isModerator === true
        }
        this.canMoveChild = () => {
            return this.isCreator === true || this.isModerator === true || this.isAdmin === true
        }
        this.deleteChild = (child) => {
            return TodoService.deleteChild(child).then(() => this.$onInit())
        }
    })
    .component('todoMenu', {
        templateUrl: 'app/todo/list-menu.html',
        controller: function ($rootScope, $state, $stateParams) {
            this.$onChanges = () => {
                this.filter = $stateParams.filter
                this.projectNone = $stateParams.projectNone
            }
            this.search = (filter) => {
                this.filter = filter
                $state.go($state.current, {filter: this.filter}, {inherit: true, reload: false, notify: false});
            }

            this.toggleProjectNone = () => {
                if (this.projectNone === true) {
                    delete this.projectNone
                } else {
                    this.projectNone = true
                }
                // this.refreshVariables()
                $state.go($state.current, {projectNone: this.projectNone}, {inherit: true, reload: false, notify: false});
            }
        }
    })
    .component('todoListStatus', {
        bindings: {
            filters: '<',
            statistics: '<'
        },
        templateUrl: 'app/todo/list-status.html',
        controller: function ($scope, $state, $stateParams, Todo, TodoService) {
            this.$onChanges = () => {
            }
        }
    })
    .component('todoListFilters', {
        bindings: {
            filters: '<',
            statistics: '<'
        },
        templateUrl: 'app/todo/list-filters.html',
        controller: function ($scope, $state, $stateParams, Todo, TodoService) {
            this.reset = () => {
                this.filters = {filter: this.filters.filter}
                this.search()
            }
            this.search = () => {
                let reload = this.arePropertiesEqual(this.filters, $stateParams)
                $state.go($state.current, angular.copy(this.filters), {inherit: false, reload: reload, notify: false});
            }
            this.arePropertiesEqual = (obj1, obj2) => {
                return Object.keys(obj1).every(key =>
                    obj2.hasOwnProperty(key) && angular.equals(obj1[key], obj2[key])
                );
            }
            this.onResponsibleNoneChanged = (value) => {
                this.filters.responsibleNone = value
                $state.go($state.current, this.filters, {inherit: false, reload: false, notify: false});
            }
            this.onModeratorNoneChanged = (value) => {
                this.filters.moderatorNone = value
                $state.go($state.current, this.filters, {inherit: false, reload: false, notify: false});
            }
            this.onSupervisorNoneChanged = (value) => {
                this.filters.supervisorNone = value
                $state.go($state.current, this.filters, {inherit: false, reload: false, notify: false});
            }
            this.$onChanges = () => {
            }
        }
    })
    .component('todoList', {
        bindings: {
            page: '<',
            filters: '<',
            statistics: '<',
            viewMode: '<'
        },
        templateUrl: 'app/todo/list-content.html',
        controller: function ($scope, $state, $stateParams, Todo, TodoService) {
            this.TodoService = TodoService
            this.statusOrder = [null].concat(TodoService.statuses())

            this.$onChanges = () => {
                this.currentTime = moment().startOf('day');
                this.kanbanColumns = this.buildKanbanColumns();

                // this.comments = {}
                // let ids = this.page.list.map(c => c.id);
                // Todo.lastComments({ids: ids}).$promise.then(comments => {
                //     let sorted = comments.sort((a, b) => a.createdTime < - b.createdTime);
                //     sorted.forEach(comment => this.comments[comment.entityId] = comment)
                // })
            }

            this.refresh = () => {
                Todo.table($stateParams).$promise
                    .then(page => {
                        this.page = page
                        this.kanbanColumns = this.buildKanbanColumns();
                    })
                Todo.tableStatistics($stateParams).$promise.then(statistics => this.statistics = statistics)
            }

            this.isKanbanView = () => this.viewMode === 'kanban';
            this.getStatusKey = status => status == null ? 'NULL' : status;
            this.getStatusLabel = status => status == null ? 'Brak statusu' : `todo.status.${status}`;
            this.getFilteredStatuses = () => {
                if (this.filters == null) {
                    return this.statusOrder;
                }

                const selectedStatuses = Array.isArray(this.filters?.status) ? this.filters.status : [];
                const visibleStatuses = this.statusOrder.filter(status => {
                    if (status == null) {
                        return this.filters?.statusNull === true;
                    }
                    return selectedStatuses.includes(status);
                });

                return visibleStatuses;
            };
            this.buildKanbanColumns = () => this.getFilteredStatuses().map(status => ({
                key: this.getStatusKey(status),
                status: status,
                items: (this.page?.list || []).filter(item => item.status === status)
            }));
            this.isDelayed = item => {
                const {status, dateOfIssue} = item;
                return this.isAfterCurrentTime(dateOfIssue) && (status == null || !["DONE_NEGATIVE", "DONE_POSITIVE"].includes(status));
            };
            this.isAfterCurrentTime = time => time != null && this.currentTime.isAfter(time);

            $scope.$on('todo.updated', () => this.refresh())
            $scope.$on('todo.deleted', () => this.refresh())
            $scope.$on('task-project.updated', () => this.refresh())
            $scope.$on('document.comments.added', (event, data) => {
                if (data != null && data.type === 'todo') {
                    this.refresh();
                }
            })
        }
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: "ROLE_TODO",
            path: "/todo?statusNull=true&status=SCHEDULED&status=STARTED&status=ACCOMPLISHED&status=VERIFICATION",
            ico: "fa fa-fw fa-check-square-o",
            name: 'todo.menu',
            order: 51
        });
    })
    .controller('TodoShowController', function (item, $state, $stateParams, $scope, $window, Todo, TodoService, Principal) {
        this.id = $stateParams.id;
        this.item = item;

        this.TodoService = TodoService

        this.$onInit = () => {
            this.refreshPrivileges()
            Todo.subTodo({id: this.id}).$promise.then(items => this.children = items)
            this.loadPredecessors()
            this.loadSuccessors()
        }
        this.loadPredecessors = () => Todo.predecessors({id: this.id}).$promise.then(items => this.predecessors = items)
        this.loadSuccessors = () => Todo.successors({id: this.id}).$promise.then(items => this.successors = items)

        $scope.$on('todo.updated', () => $state.reload())
        $scope.$on('todo.deleted', () => this.cancel())
        $scope.$on('task-project.updated', () => $state.reload())
        $scope.$on('todo.predecessor.updated', () => this.loadPredecessors())
        $scope.$on('todo.successor.updated', () => this.loadSuccessors())

        this.saveSubTodo = () => {
            return Todo.subTodoSave({id: this.item.id}, this.subTodo).$promise.then(() => {
                this.$onInit()
                delete this.subTodo
            })
        }

        this.refreshPrivileges = () => {
            Principal.currentUser().then(user => {
                this.isCreator = this.item.audit.createdBy.id === user.id && this.item.moderator == null
                this.isModerator = this.item.moderator != null && this.item.moderator.id === user.id
                this.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN'])
            })
        }

        this.canModifyPredecessorsSuccessors = () => {
            return this.isCreator === true || this.isModerator === true || this.isAdmin === true
        }

        this.canDeleteChild = () => {
            return this.isCreator === true || this.isModerator === true
        }
        this.canMoveChild = () => {
            return this.isCreator === true || this.isModerator === true || this.isAdmin === true
        }
        this.deleteChild = (child) => {
            return TodoService.deleteChild(child).then(() => $state.reload())
        }

        this.cancel = () => {
            if ($window.history.length > 2)
                $window.history.back();
            else {
                $state.go('todoList');
            }
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('todoListAbstract', {
            abstract: true,
            parent: 'app',
            data: {
                authorities: ['ROLE_TODO']
            },
            views: {
                'content@': {
                    templateUrl: 'app/todo/list.html',
                    controllerAs: '$ctrl',
                    controller: function (TodoService, $state, $stateParams) {
                        this.TodoService = TodoService
                        this.isView = view => view === 'kanban' ? $state.includes('todoKanban') : $state.includes('todoList')
                        this.changeView = view => {
                            if (this.isView(view)) {
                                return;
                            }
                            $state.go(view === 'kanban' ? 'todoKanban' : 'todoList', angular.copy($stateParams), {inherit: false});
                        }
                    },
                }
            }
        })
        $stateProvider.state('todoList', {
            parent: 'todoListAbstract',
            url: '/todo?{page:int}&{size:int}&sort&search&periodStart&periodEnd&project&{projectNone:boolean}&filter&status&{statusNull:boolean}&creator&responsible&moderator&supervisor&createdStart&createdEnd&{responsibleNone:boolean}&{moderatorNone:boolean}&{supervisorNone:boolean}',
            params: {
                filter: {value: 'all'},
                // status: {array: true, value: [], squash: false},
                project: {array: true, type: "int"},
                status: {array: true, value: ['SCHEDULED', 'STARTED', 'ACCOMPLISHED', 'VERIFICATION']},
                statusNull: {value: true},
                // search: { dynamic: true },
            },
            views: {
                'list-content@^': 'todoList',
                'list-status@^': 'todoListStatus',
                'list-filters@^': 'todoListFilters'
            },
            resolve: {
                statistics: (Todo, $stateParams) => Todo.tableStatistics(angular.copy($stateParams)).$promise,
                filters: ($stateParams) => angular.copy($stateParams),
                page: (Todo, $stateParams) => Todo.table(angular.copy($stateParams)).$promise,
                viewMode: () => 'table'
            }
        });
        $stateProvider.state('todoKanban', {
            parent: 'todoListAbstract',
            url: '/todo/kanban?{page:int}&{size:int}&sort&search&periodStart&periodEnd&project&{projectNone:boolean}&filter&status&{statusNull:boolean}&creator&responsible&moderator&supervisor&createdStart&createdEnd&{responsibleNone:boolean}&{moderatorNone:boolean}&{supervisorNone:boolean}',
            params: {
                filter: {value: 'all'},
                project: {array: true, type: "int"},
                status: {array: true, value: ['SCHEDULED', 'STARTED', 'ACCOMPLISHED', 'VERIFICATION']},
                statusNull: {value: true},
            },
            views: {
                'list-content@^': 'todoList',
                'list-status@^': 'todoListStatus',
                'list-filters@^': 'todoListFilters'
            },
            resolve: {
                statistics: (Todo, $stateParams) => Todo.tableStatistics(angular.copy($stateParams)).$promise,
                filters: ($stateParams) => angular.copy($stateParams),
                page: (Todo, $stateParams) => Todo.table(angular.copy($stateParams)).$promise,
                viewMode: () => 'kanban'
            }
        });
        $stateProvider.state('todoShow', {
            parent: 'app',
            url: '/todo/{id}',
            data: {
                authorities: ['ROLE_TODO']
            },
            views: {
                'content@': {
                    templateUrl: 'app/todo/show.html',
                    controller: 'TodoShowController',
                    controllerAs: '$ctrl'
                }
            },
            resolve: {
                item: (Todo, $stateParams) => Todo.get({id: $stateParams.id}).$promise
            }
        });
    })
